import { fromJS } from 'immutable';

import { SET_INITIAL_SUBMIT_TYPE, SET_INITIAL_DELIVERABLE } from './constants';

const initialState = fromJS({
  initialSubmitType: 'url',
  selectedDeliverable: null,
  assetType: null,
  isUploadActive: true,
  isUrlActive: true,
  isTextActive: true,
});

function deliverableSubmitReducer(state = initialState, action) {
  switch (action.type) {
  case SET_INITIAL_SUBMIT_TYPE:
    return state
      .set('initialSubmitType', action.data.submitType)
      .set('assetType', action.data.assetType)
      .set('isUploadActive', action.data.isUploadActive)
      .set('isUrlActive', action.data.isUrlActive)
      .set('isTextActive', action.data.isTextActive);
  case SET_INITIAL_DELIVERABLE:
    return state
      .set('selectedDeliverable', action.data.deliverableId);
  default:
    return state;
  }
}

export default deliverableSubmitReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable-submit-modal/reducer.js
 **/